<template>
    <div class="userList">
        <el-table :data="tableData" style="width: 100%">
            <el-table-column label="用户名称" class-name="usernameBox center">
                <template slot-scope="scope">
                    <div class="username">
                        <div class="headimageurl">
                            <img :src="scope.row.headimageurl" alt="">
                        </div>
                        <div class="name">{{scope.row.name}}</div>
                    </div>
                </template>
            </el-table-column>
            <el-table-column prop="mobileno" label="手机号码" class-name="center"></el-table-column>
            <el-table-column prop="datetime" label="领券时间" class-name="center"></el-table-column>
            <el-table-column label="状态" class-name="center">
                <template slot-scope="scope">
                    <div class="status" :class="scope.row.status | filtersStatus">
                        {{scope.row.statusname}}
                    </div>
                </template>
            </el-table-column>
            <el-table-column prop="ordertime" label="用券时间" class-name="center"></el-table-column>
            <el-table-column prop="ordermoney" label="订单金额" class-name="center"></el-table-column>
            <el-table-column prop="paymoney" label="实付金额" class-name="center"></el-table-column>
            <el-table-column prop="dismoney" label="优惠金额" class-name="center"></el-table-column>
            <el-table-column label="操作" class-name="right">
                <template slot-scope="scope">
                    <div class="handle">
                        <span v-if="scope.row.status === 0" @click="cancellation(scope.row)">作废</span>
                    </div>
                </template>
            </el-table-column>
        </el-table>
        <Page :total="page.total" @getList="getCoupnvoucherInfoByCustomer" />
    </div>
</template>
<script>
import {getCoupnvoucherInfoByCustomer, updateCoupongetinfoStatus} from 'api/marketingCenterApi'
import {mapActions} from 'vuex'
import Page from 'base/page/page3'
export default {
    data() {
        return {
            tableData: [],
            page: {
                page: 1,
                pageSize: 10,
                total: 0
            }
        }
    },
    created() {
    },
    mounted() {
        this.getCoupnvoucherInfoByCustomer(this.page)
    },
    methods: {
        // 作废
        cancellation(row) {
            console.log(row)
            this.$confirm('作废后不可恢复，是否确定作废该优惠券？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消'
            }).then(() => {
                this.setLoading(true)
                updateCoupongetinfoStatus({
                    data: {innerid: row.innerid},
                    success: res => {
                        this.setLoading(false)
                        row.status = 100
                        row.statusname = '已作废'
                    },
                    error: res => {
                        this.setLoading(false)
                        this.$message.error(res.msg)
                    }
                }) 
            }).catch(() => {
            })
        },
        getCoupnvoucherInfoByCustomer(page) {
            this.setLoading(true)
            const params = {
                page: page.page,
                pageSize: page.pageSize,
                couponvoucherid: this.$route.query.couponvoucherid
            }
            getCoupnvoucherInfoByCustomer({
                data: params,
                success: res => {
                    // const obj = {
                    //     innerid: '',
                    //     ordertime: '2019-05-20 18:12:21',
                    //     ordermoney: '299.00',
                    //     paymoney: '199.00',
                    //     dismoney: '100.00',
                    //     status: 1,
                    //     statusname: '未使用',
                    //     headimageurl: require('@/common/images/agencyService/notAvailable.png'),
                    //     name: '熊明',
                    //     mobileno: '14233262174',
                    //     datetime: '2019-05-20 18:12:21'
                    // }
                    // res.data.content.push(obj)
                    this.setLoading(false)
                    // res.data.pageinfo.rowCount = 20
                    this.tableData = res.data.content
                    if (page.page === 1) {
                        this.page.total = res.data.pageinfo.rowCount
                    }
                },
                error: res => {
                    this.setLoading(false)
                    this.$message.error(res.msg)
                }
            })
        },
        ...mapActions([
            'setLoading'
        ])
    },
    filters: {
        filtersStatus(status) {
            let className = ''
            switch(status) {
                case 0: 
                    className =  'status1'
                    break
                case 9: 
                    className =  'status2'
                    break
                case 10: 
                    className =  'status3'
                    break
                case 100: 
                    className =  'status4'
                    break
            }
            return className
            console.log(status)
        }
    },
    components: {
        Page
    }
}
</script>
<style lang="scss">
    .userList {
        .el-table {
            .usernameBox {
                .username {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    .headimageurl {
                        width: 60px;
                        height: 60px;
                        margin-right: 15px;
                        img {
                            width: 60px;
                            height: 60px;
                            border-radius: 50%;
                        }
                    }
                    .name {
                        width: 60px;
                        font-size: 14px;
                        color: #606266;
                        text-align: left;
                        text-overflow: ellipsis;
                        overflow: hidden;
                        white-space: nowrap;
                    }
                }
            }
            .center {
                .cell {
                    text-align: center;
                }
            }
            .right {
                text-align: right;
                .handle {
                    span {
                        color: #439FFE;
                        font-size: 14px;
                        cursor: pointer;
                    }
                }
            }
            .status {
                &.status1 {
                    color: #F1C205;
                }
                &.status2 {
                    color: #999999;
                }
                &.status3 {
                    color: #67C23A;
                }
                &.status4 {
                    color:#999999;
                }
            }
        }
    }
</style>